// このファイルは自動生成されています。直接編集しないでください。
// 更新する場合は `bundle exec rails master_constants_for_frontend:generate_ts` を実行してください。

export const JOB_TYPE_CATEGORY = {
  BIYO_ID: 1, // 美容
  RELAXATION_ID: 2, // リラクゼーション
  CHIRYO_ID: 3, // 治療
  SPORTS_ID: 4, // スポーツ・フィットネス
  KAIGO_ID: 5, // 介護・看護・リハビリ
  OTHER_ID: 6, // その他
  SHIKA_ID: 7, // 歯科
  RESTAURANT_ID: 8, // 飲食・レストラン
  HOTEL_ID: 9, // 宿泊・ホテル
  MEDICAL_ID: 10, // 医療
} as const;

export type JobTypeCategoryId = (typeof JOB_TYPE_CATEGORY)[keyof typeof JOB_TYPE_CATEGORY];
